// extracted by mini-css-extract-plugin
export default {"section":"styles_section__rDCdh","img":"styles_img__4Xj7+","heading":"styles_heading__jVDgK","para":"styles_para__MBrSV"};